import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        primary: '#16b1ff',
        accent: '#FF5733',
        secondary: '#E2E3E6',
        error: '#b71c1c',
        editIcon: '#283593',
        toolbarColor: '#E0E0E0',
        tabToolbar: '#ECEFF1',
        menuColor: '#808080',
        flatButton: '#3F51B5'
      },
    },
  }
});
